import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PreOrderDetails } from './pre-order.model';
import { preOrderDetailsBuilderUI } from './pre-order.mapper';
import { format } from '@shared/utilities/formatEmail';

@Injectable({
  providedIn: 'root'
})
export class PreOrderService {
  baseUrl = environment.apiUrl;

  constructor(private _http: HttpClient) {}

  getPreOrderDetails(id): Observable<PreOrderDetails> {
    return this._http
      .get(`${this.baseUrl}/properties/${id}/pre-order-details`)
      .pipe(map(preOrderDetailsBuilderUI));
  }

  setPreOrderStep(userName, stepId) {
    return this._http
      .post(`${this.baseUrl}/users/${format(userName)}/signup-update-step`, {
        newStepID: stepId
      })
      .pipe(map(preOrderDetailsBuilderUI));
  }

  getUserPreOrderDetails(username, preOrderId): Observable<any> {
    return this._http.get(
      `${this.baseUrl}/users/${format(
        username
      )}/pre-order-details/${preOrderId}`
    );
  }
}
